import React from 'react';
import {
  isAnonymous,
  ShareChannel,
} from '../../../modules/share';
import Analytics from '../../../modules/analytics';

import { ShareProps } from './types';
import { ShareTrigger, ShareTriggerProps } from './ShareTrigger';
import { BasicShareArrowButton } from './ShareButton/BasicShareArrowButton';

type DirectShareButtonProps = ShareProps & {
  /** Appearance of the component  */
  appearance?: 'basic-share-arrow-icon'
  ;
  /** Close modal when share action is taken */
  closeModalOnShare?: boolean;
  isOwnProfile?: boolean;
};

/**
 * The Share button that opens a native share modal when possible, and falls
 * back to showing the ShareMenu in a modal when not possible.
 *
 * Example:
 *   <DirectShareButton target="profile" user={user} provider={provider} />
 */
export default (function DirectShareButton(props) {
  const { user } = props;
  let userId: number;

  if (!isAnonymous(user)) {
    userId = user.user_id;
  }

  const handleShareTrigger = () => {
    Analytics.track('client_share_click', {
      surface: 'profile',
      user_id: userId,
      provider_id: props.provider?.id,
    });
  };

  const handleShareComplete = (channel?: ShareChannel) => {
    Analytics.track('client_profile_shared', {
      channel,
      profile_type: props.provider?.type,
      [`${props.provider?.type}_id`]: props.provider?.id,
      user_id: userId,
    });

    if (typeof props.onShareComplete === 'function') props.onShareComplete(channel);
  };

  const renderTrigger: ShareTriggerProps['renderTrigger'] = onClick => <BasicShareArrowButton onClick={onClick} />;

  return (
    <ShareTrigger
      {...props}
      onShareTrigger={handleShareTrigger}
      onShareComplete={handleShareComplete}
      mode="direct"
      renderTrigger={renderTrigger}
      additionalParams={props.message?.urlParams || props.additionalParams || []}
    />
  );
} as React.FC<DirectShareButtonProps>);
